// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   api:'http://inspectmite.net/api/',
//   apiSite:'http://inspectmite.net/',
//   oldSite:'http://twinhouse.net/',
//   doSpace:'https://twininspection-development.nyc3.digitaloceanspaces.com',
//

const parsedUrl = new URL(window.location.href);
const baseUrl = parsedUrl.host;

let constArray = {
    production: false,
    api: 'https://app.dev.twininspections.com/api/',
    apiSite: 'https://app.dev.twininspections.com/',
    oldSite: 'https://dev.twininspections.com/',
    doSpace: 'https://twininspection-development.nyc3.digitaloceanspaces.com',
    appDashboard: 'twinhouse',
    inspectionReports: true,
};

if (baseUrl === 'app.lite.twininspections.com') {
    constArray = {
        production: false,
        api: 'https://app.lite.twininspections.com/api/',
        apiSite: 'https://app.lite.twininspections.com/',
        oldSite: 'https://lite.twininspections.com/',
        doSpace: 'https://twininspection-development.nyc3.digitaloceanspaces.com',
        appDashboard: 'twinhouse',
        inspectionReports: true,
    };
}

export const environment = constArray;

